/* tslint:disable */
/* eslint-disable */
/**
 * Poizon API Counter
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const CounterType = {
    ApiRequests: 'API_REQUESTS',
    TranslationSymbols: 'TRANSLATION_SYMBOLS',
    GptTokens: 'GPT_TOKENS',
    PoizonRuRequests: 'POIZON_RU_REQUESTS',
    PoizonComRequests: 'POIZON_COM_REQUESTS',
    TmallRequests: 'TMALL_REQUESTS',
    DewuRequests: 'DEWU_REQUESTS',
    ProductStorageRequests: 'PRODUCT_STORAGE_REQUESTS',
    GoatRequests: 'GOAT_REQUESTS',
    PoizonResellRequests: 'POIZON_RESELL_REQUESTS',
    AllSourcesRequests: 'ALL_SOURCES_REQUESTS'
} as const;

export type CounterType = typeof CounterType[keyof typeof CounterType];



